import { encrypt } from '@/common/securityUtils';

export const statusTypeMap: Record<string, string> = {
  approved: '6',
  pending: '3',
  rejected: '4',
};

export const encryptedStatusTypeMap: Record<string, string> = Object.fromEntries(
  Object.entries(statusTypeMap).map(([type, encryptedValue]) => [type, encrypt(encryptedValue)]),
);

export const STORE_SETUP_STEPS = [
  {
    step: 1,
    title: 'storeManagement.premiumStores.manageStoreInformation.formTitle.basicInfo',
    description: 'storeManagement.premiumStores.manageStoreInformation.formSubtitle.basicInfo',
    fields: [
      'storeName',
      'storeNameFurigana',
      'groupName',
      'description',
      'businessType',
      'identificationType',
      'kycFront',
      'kycBack',
      'passportImage',
      'insuranceCardImage',
      'businessCertificateImage',
      'corporateRegistryImage',
      'companyName',
      'companyNameFurigana',
      'ceoFullName',
      'ceoFurigana',
      'companyAddress',
      'landlineNumber',
      'mobileNumber',
      'emailAddress',
      'username',
      'profileImage',
      'coverImage',
    ],
  },
  {
    step: 2,
    title: 'storeManagement.premiumStores.manageStoreInformation.formTitle.storeInfo',
    description: 'storeManagement.premiumStores.manageStoreInformation.formSubtitle.storeInfo',
    fields: [
      'latitude',
      'longitude',
      'postalCode',
      'prefecture',
      'city',
      'street',
      'buildingNo',
      'room',
      'workingTimeFrom',
      'workingTimeTo',
      'lastEntryTime',
    ],
  },
] as const;

export const PREFECTURE = [
  { label: 'test', value: '1' },
  { label: 'test', value: '2' },
  { label: 'test', value: '3' },
  { label: 'test', value: '4' },
];

export const businessTypeOptions = [
  { label: '法人', value: '1', labelEng: 'Corporation' },
  {
    label: '個人事業主',
    value: '2',
    labelEng: 'Sole Proprietorship',
  },
];
